export const notificationsCollectionGuard = 'GET /notifications/default';
